import ImageContainer from '../General/ImageContainer';
import './TabberStyle.css';

export const allTabs = [
    { key: 'patient', text: 'Patient', icon: 'user' },
    { key: 'insurance', text: 'Insurance', icon: 'dollar-sign' },
    { key: 'income & eligibility', text: 'Income & Eligibility', icon: 'money-bill-1-solid' },
    { key: 'medical', text: 'Medical', icon: 'heart-pulse' },
    { key: 'provider', text: 'Provider', icon: 'stethoscope' },
    { key: 'order / logistics', text: 'Order & Logistics', icon: 'clipboard-list' },
    { key: 'other', text: 'Other', icon: 'info' },
    { key: 'attestation & signature', text: 'Attestation & Signature', icon: 'clipboard-check' }
]

const reviewTab = { key: 'review & submit', text: 'Review & Submit', icon: 'envelope' };

const tabClass = "de-tab";
const tabWrapperClass = "de-tab-wrapper";
const firstTabClass = "first-tab";
const lastTabClass = "last-tab";
const activeClass = "is-active";

const styles = {
    tabIcon: {
        width: '20px',
        height: '20px'
    },
    tabIconWrapper: {
        minWidth: '30px',
        marginRight: '8px'
    },
    statusIcon: {
        width: '20px',
        height: '20px'
    },
    statusIconWrapper: {
        minWidth: '30px',
        marginLeft: '-22px'
    }
}

const Tabber = props => {
    const { activeTab, completed, required, disabled, onChange } = props;

    return <div className='tabber'>
        {allTabs.map((tab, idx) => {
            const key = tab.key;
            const isActive = activeTab === key;
            const isComplete = completed?.includes(key);
            const isRequired = required?.includes(key);
            const isDisabled = disabled?.includes(key);

            return <Tab
                tab={tab}
                active={isActive}
                disabled={isDisabled}
                completed={isComplete}
                required={isRequired}
                onClick={onChange}
                index={idx}
                key={key}
            />
        })}
        <Tab tab={reviewTab} active={activeTab === reviewTab.key} completed={false} required={false} disabled={completed?.length !== 8} onClick={onChange} index={allTabs?.length} key={reviewTab.key} />
    </div>
}

const Tab = props => {
    const { tab, active, disabled, completed, required, onClick, index } = props;

    var className = tabClass;
    var wrapperClassName = tabWrapperClass;
    if (active) {
        className += ' ' + activeClass;
        wrapperClassName += ' ' + activeClass;
    }
    if (index === 0) className += ' ' + firstTabClass;
    if (index === allTabs?.length) className += ' ' + lastTabClass;
    return <div className={wrapperClassName}>
        <a
            data-control={'de-tab-' + tab.key}
            className={className}
            required={required}
            disabled={disabled}
            onClick={(ev) => onClick(tab.key)}
        >
            <div style={styles.statusIconWrapper}>{StatusIcon(completed, disabled, required, tab.key)}</div>
            <div style={styles.tabIconWrapper}><ImageContainer iconName={tab.icon} styles={styles.tabIcon} className='fontawesomeTextGrey' /></div>
            <span style={{ whiteSpace: 'break-spaces', textAlign: 'left' }}>{tab.text}</span>
        </a>
        {active && <div className='de-tab-decoration'></div>}
    </div>
}

const StatusIcon = (completed, disabled, required, tabKey) => {
    if (disabled || (!required && tabKey !== reviewTab.key)) return;
    if (completed || (!disabled && tabKey === reviewTab.key)) {
        return <ImageContainer iconName={'check'} styles={styles.statusIcon} className='fontawesomeIvyGreen' />
    }
    else {
        return <ImageContainer iconName={'circle-exclamation-solid'} styles={styles.statusIcon} className='fontawesomeTangerineOrange' />
    }
}

export default Tabber;
